import { EventViewData } from 'components/eventView/pages/eventData';

export const Seafood2024Event: EventViewData = {
    eventId: 'seafood',
    mapId: '57e30b96-43ca-4c55-b052-44e5d072d6ea',
    guideId: 'b6c3c8ae-e398-4c60-8196-4b69a9353b72'
};
